import React, { useState, useEffect } from "react";
import apiCall from "./../../API/API";
import { toast } from "react-toastify";
import { CiCirclePlus } from "react-icons/ci";
import { Row, Col, Container, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

const CoinSettings = () => {
  const [coinData, setCoinData] = useState();
  const dispatch = useDispatch();
  const fetchIcon = async () => {
    try {
      const { data, error } = await apiCall("GET", "/get-company-info");
      // console.log("data----", data);
      if (data) {
        console.log(data?.company_info?.coin_buy_price);
        setCoinData(data?.company_info?.coin_buy_price);
      }
    } catch (e) {
      console.log(e.message);
    }
  };

  useEffect(() => {
    fetchIcon();
  }, []);

  const handleUpdate = async () => {
    try {
      const body = { coin_buy_price: coinData };
      console.log("body", body);
      const { data, error } = await apiCall("POST", `/update-coin`, body);
      if (error) {
        toast.error(error.message || "An error occurred");
      } else {
        toast.success(data.message || "Coin updated successfully!");
        fetchIcon();
      }
    } catch (error) {
      toast.error(error.message || "An error occurred");
    }
  };

  return (
    <React.Fragment>
      <Container>
        <div className="bonanza-settings">
          <div className="input-row1">
            <h2>Coin Price</h2>
            <div className="input-group2">
              <label>Coin Price:</label>
              <input
                type="number"
                name="income"
                placeholder="Enter Coin Price"
                value={coinData}
                onChange={(e) => setCoinData(e.target.value)}
                required
              />
            </div>
            <div className="button-container">
              <Button type="submit" variant="primary" onClick={handleUpdate}>
                Update
              </Button>
            </div>
          </div>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default CoinSettings;